import { render } from "./orthopedic_imaging.vue?vue&type=template&id=2f4626c0&scoped=true"
import script from "./orthopedic_imaging.vue?vue&type=script&lang=js"
export * from "./orthopedic_imaging.vue?vue&type=script&lang=js"

import "./orthopedic_imaging.vue?vue&type=style&index=0&id=2f4626c0&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4626c0"]])

export default __exports__